// GA4 + PostHog event helper. Safe no-op until gtag/posthog are loaded
// (both are deferred in public/index.html). Mirrors events to PostHog
// when present so funnels can be checked in either tool.
//
// Naming: GA4-standard names where they exist (`sign_up`, `begin_checkout`,
// `purchase`, `generate_lead`); custom names for our lead magnets
// (`lead_demo`, `lead_ai_detector`, `lead_affiliate`, `chat_started`).
//
// After deploy, mark these as "Key events" in GA4 Admin → Events:
//   purchase, sign_up, lead_demo, lead_ai_detector, lead_affiliate, chat_started

export function track(eventName, params = {}) {
  if (typeof window === "undefined") return;

  // GA4 via gtag
  if (typeof window.gtag === "function") {
    try {
      window.gtag("event", eventName, params);
    } catch {
      // never throw from analytics
    }
  } else if (Array.isArray(window.dataLayer)) {
    // gtag.js still loading — push to dataLayer; gtag picks it up on ready
    try {
      window.dataLayer.push({ event: eventName, ...params });
    } catch {
      // ignore
    }
  }

  // PostHog mirror (loaded in public/index.html)
  if (window.posthog && typeof window.posthog.capture === "function") {
    try {
      window.posthog.capture(eventName, params);
    } catch {
      // ignore
    }
  }
}

// Convenience wrappers — keep call sites short and consistent.

export function trackLead(magnet, extra = {}) {
  track(`lead_${magnet}`, { lead_source: magnet, ...extra });
  // Also fire GA4-standard `generate_lead` so it shows in default reports.
  track("generate_lead", { lead_source: magnet, ...extra });
}

export function trackChatStarted(extra = {}) {
  track("chat_started", extra);
}

export function trackSignUp(method = "email", extra = {}) {
  track("sign_up", { method, ...extra });
}

export function trackBeginCheckout(plan) {
  if (!plan) return;
  track("begin_checkout", {
    currency: "USD",
    value: plan.value,
    items: [
      {
        item_id: plan.id,
        item_name: `SEOintent ${plan.name}`,
        item_category: plan.billing_cycle,
        price: plan.value,
        quantity: 1,
      },
    ],
  });
}

export function trackPurchase({ transactionId, plan, value, billingCycle }) {
  track("purchase", {
    transaction_id: transactionId,
    currency: "USD",
    value: Number(value) || 0,
    items: [
      {
        item_id: plan,
        item_name: `SEOintent ${plan}`,
        item_category: billingCycle,
        price: Number(value) || 0,
        quantity: 1,
      },
    ],
  });
}
